__turbopack_context__.v({
  "Date": "media-view-module__dnH84W__Date",
  "Duration": "media-view-module__dnH84W__Duration",
  "ErrorIcon": "media-view-module__dnH84W__ErrorIcon",
  "Media": "media-view-module__dnH84W__Media",
  "Play": "media-view-module__dnH84W__Play",
  "VideoShow": "media-view-module__dnH84W__VideoShow",
  "isPreview": "media-view-module__dnH84W__isPreview",
});
